import React from "react";
import hotel1 from "../../../../images/tours/norway/hotel/norway1.jpg";
import hotel2 from "../../../../images/tours/norway/hotel/norway2.avif";
import hotel3 from "../../../../images/tours/norway/hotel/norway3.jpg";
import hotel4 from "../../../../images/tours/norway/hotel/norway4.avif";
import hotel5 from "../../../../images/tours/norway/hotel/norway5.avif";
import hotel6 from "../../../../images/tours/norway/hotel/norway6.avif";
import hotel7 from "../../../../images/tours/norway/hotel/norway7.jpg";
import hotel8 from "../../../../images/tours/norway/hotel/norway8.avif";
import AccommodationTab from "../../common/AccommodationTab";

const NorwayAccommodationTab = () => {

    const images = [
        hotel1,
        hotel2,
        hotel3,
        hotel4,
        hotel5,
        hotel6,
        hotel7,
        hotel8,
    ];

    return (
        <AccommodationTab
            content={{
                title: 'norway_hotel_title',
                descriptions: 'norway_hotel_text',
                images: images
            }}
        />
    );
};

export default NorwayAccommodationTab;
